module.exports = __webpack_public_path__ + "img/almaty4.9019ed3a.jpg";